import React from 'react';

const AdminDashboard = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <h1 className="text-3xl font-bold">Admin Paneline Hoş Geldiniz!</h1>
        </div>
    );
};

export default AdminDashboard;
